// src/App.jsx
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import TabsLayout from './layouts/TabsLayout';
import Login from './pages/login/Login';
import SplashScreen from './components/SplashScreen';

// Importar todas as telas das tabs
import Dashboard from './pages/tabs/index';
import Historico from './pages/tabs/Historico';
import Perfil from './pages/tabs/Perfil';
import RegistrarAbastecimento from './pages/tabs/RegistrarAbastecimento';
import Validando from './pages/tabs/Validando';
import Processando from './pages/tabs/Processando';
import Conclusao from './pages/tabs/Conclusao';
import './App.css';

// Componente de rota protegida
const PrivateRoute = ({ children }) => {
  const { user, tokenReady, loading } = useAuth();
  
  console.log('[PrivateRoute] Estado:', { user: !!user, tokenReady, loading });
  
  if (loading) {
    return <SplashScreen />;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  const { loading, tokenReady } = useAuth();
  
  console.log('[App] Estado global:', { loading, tokenReady });

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      {/* Rotas protegidas com layout de tabs */}
      <Route 
        path="/" 
        element={
          <PrivateRoute>
            <TabsLayout />
          </PrivateRoute>
        }
      >
        {/* Rotas aninhadas que serão renderizadas no <Outlet /> */}
        <Route index element={<Dashboard />} />
        <Route path="inicio" element={<Dashboard />} />
        <Route path="historico" element={<Historico />} />
        <Route path="perfil" element={<Perfil />} />
        <Route path="registrarAbastecimento" element={<RegistrarAbastecimento />} />
        <Route path="validando" element={<Validando />} />
        <Route path="processando" element={<Processando />} />
        <Route path="conclusao" element={<Conclusao />} />
      </Route>
      
      {/* Redirecionar qualquer outra rota para home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;